// extracted by mini-css-extract-plugin
export var alignCenter = "_92-d";
export var bannerShown = "_92-6";
export var buttonContent = "_92-0";
export var cardList = "_92-1";
export var centerContent = "_92-2";
export var chevron = "_92-3";
export var closePanelButton = "_92-k";
export var conversationContextContainer = "_92-l";
export var conversationDetailContainer = "_92-4";
export var detailWrapper = "_92-7";
export var dropdownButton = "_92-e";
export var dropdownTitle = "_92-9";
export var fullHeight = "_92-5";
export var hidden = "_92-a";
export var icon = "_92-b";
export var mergeSuggestionWrapper = "_92-m";
export var panel = "_92-i";
export var portalButtonsWrapper = "_92-c";
export var right = "_92-j";
export var tableSummaryContainer = "_92-8";
export var tableSummaryHeader = "_92-g";
export var threeDotsButton = "_92-f";
export var wide = "_92-h";